import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "app-wrapper"
};
var _hoisted_2 = {
  class: "app-main"
};
import { onMounted } from "vue";
import BottomNav from "./components/BottomNav.vue";
import { Persistent } from "@/utils/cache/persistent";
import { SESSION_KEY_CUSTOMER_REMARK, SESSION_KEY_IS_PRIVACY_POLICY_CHECKED, SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE, SESSION_KEY_IS_USER_TERMS_CHECKED, SESSION_KEY_SELECTED_PAYMENT_METHOD } from "@/constant/storageKey";
import { useCartStore } from "@/store/cartStore";
export default {
  __name: 'HomeLayout',
  setup: function setup(__props) {
    var cartStore = useCartStore();
    onMounted(function () {
      // 清空部分缓存数据
      Persistent.removeSession(SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE);
      Persistent.removeSession(SESSION_KEY_CUSTOMER_REMARK);
      Persistent.removeSession(SESSION_KEY_SELECTED_PAYMENT_METHOD);
      Persistent.removeSession(SESSION_KEY_IS_PRIVACY_POLICY_CHECKED);
      Persistent.removeSession(SESSION_KEY_IS_USER_TERMS_CHECKED);
      cartStore.removeCouponStorage();
      cartStore.removeCartStorage();
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view, null, {
        default: _withCtx(function (_ref) {
          var Component = _ref.Component,
            route = _ref.route;
          return [route.meta.keepAlive ? (_openBlock(), _createBlock(_KeepAlive, {
            key: 0
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024)) : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 1
          }))];
        }),
        _: 1
      })]), _createVNode(BottomNav)]);
    };
  }
};